export const checkAutoSubmitEmail = (index, data, customerEmail) => {
    if (!customerEmail || !data?.settings?.autoSubmitEmail || index === -1) return false;
    const { type, answers } = data.questionList[index];
    if (type === "input") {
        return answers.every((answer) => answer.inputType === "email");
    }
    return type === "email";
}